import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, Loader2, LogIn, ArrowLeft } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();
  const { login } = useAuth();
  const from = loc.state?.from || "/admin";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Selamat datang, Admin");
      nav(from, { replace: true });
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login gagal");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-100 via-white to-amber-50/40 px-4 py-10">
      <div className="w-full max-w-md space-y-6">
        <div className="text-center">
          <div className="inline-flex w-20 h-20 rounded-md bg-white shadow-lg items-center justify-center p-2 ring-2 ring-[#C59B27]">
            <img src="/logo-seruyan.webp" alt="Logo Kabupaten Seruyan" className="w-full h-full object-contain" />
          </div>
          <h1 className="mt-4 text-2xl font-bold text-slate-900">Portal Admin</h1>
          <p className="text-sm text-slate-600">Sekretariat DPRD Kabupaten Seruyan</p>
        </div>

        <Card className="border-slate-200 shadow-xl">
          <CardHeader className="border-b border-slate-100 bg-slate-50/50">
            <CardTitle className="text-base font-semibold text-slate-800 flex items-center gap-2">
              <LogIn className="w-4 h-4 text-[#C59B27]" /> Masuk ke Dasbor Admin
            </CardTitle>
          </CardHeader>
          <CardContent className="p-6">
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wider font-semibold text-slate-600">Email</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                       required autoFocus data-testid="login-email"
                       className="bg-white border-slate-300 focus-visible:ring-[#0B2545]" />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wider font-semibold text-slate-600">Kata Sandi</Label>
                <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                       required data-testid="login-password"
                       className="bg-white border-slate-300 focus-visible:ring-[#0B2545]" />
              </div>
              <Button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit">
                {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <LogIn className="w-4 h-4 mr-2" />}
                Masuk
              </Button>
            </form>
          </CardContent>
        </Card>

        <div className="text-center">
          <Button asChild variant="ghost" size="sm" data-testid="back-to-public">
            <Link to="/"><ArrowLeft className="w-4 h-4 mr-1" /> Kembali ke Portal Tamu</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
